import React from 'react';
import cn from 'classnames';

const Datagrid = ({ title, value, className }) => {
  return (
    <div className={cn('datagrid-item', className)}>
      <div className="datagrid-title">{title}</div>
      <div
        className="datagrid-content text-uppercase fs-8"
        style={{ wordBreak: 'break-all' }}
      >
        {value}
      </div>
    </div>
  );
};

export default Datagrid;
